import React from "react";
import { Link } from 'react-router-dom'

import Container from '../../components/Container'
import Hero from '../../components/Hero'
import Header from '../../components/Header/brandbook'
import Section from '../../components/Section'
import Icon from '../../components/Icon'
import IconDemo from '../../components/IconDemo'
import Grid from '../../components/Grid'
import Downloadable from '../../components/Downloadable'


export const path = '/brandbook/colors'

export default function BrandbookPage() {
  return (
    <div className="light">
      <Header />
      <Hero>
        <Container size="large">

          <Grid grid="1-2">
            <></>
            <>
              <h1><span className="highlight">Tools and Rules</span> <br />Colors</h1>
            </>
          </Grid>
        </Container>

      </Hero>
      <Container size="large">
      <Section>

      <Grid grid="1-2">
        <></>
        <>


          <h2>Primary colors</h2>
          <p>
            Our primary color palette is made up of three primary colors. Green is what makes us unique. We use it to turn up (or down) the volume in our communication. Together with different amounts of black and white it acts as the foundation of the Waved visual identity.
          </p>
        </>
      </Grid>

      <Grid grid="3">

        <>
          <svg viewBox="0 0 100 100">
            <rect fill="#BADD00" height="100%" width="100%"></rect>
          </svg>

          <br />
          <h3>Green Energy</h3>
          <p>PMS 2290 C<br />C34 M0 Y95 K0<br />R170 G219 B30<br />#aadb23</p>
        </>

        <>
          <svg viewBox="0 0 100 100">
            <rect fill="#0C101C" height="100%" width="100%"></rect>
          </svg>
          <br />
          <h3>Dark Space</h3>
          <p>R14 G19 B36<br />#0C101C</p>
        </>

        <>
          <svg viewBox="0 0 100 100">
            <rect fill="#fff" stroke="#f2f2f2" stroke-width="1" height="100%" width="100%"></rect>
          </svg>
          <br />
          <h3>Whitespace</h3>
          <p>R255 G255 B255<br />#FFFFFF</p>
        </>
      </Grid>
      </Section>



      <Section>

      <Grid grid="1-2">
        <></>
        <>
          <h2>Supporting colors</h2>
          <p>
            These are more functional colors used to enhance the primary ones as well as adding flavour to user interfaces and product presentation. Use them moderately.
          </p>

        </>
      </Grid>

      <Grid grid="3">

      <>
        <svg viewBox="0 0 100 50">
          <rect fill="#92b500" height="100%" width="100%"></rect>
        </svg>
        <br />
        <h3>Green Readable</h3>
        <p>#92b500</p>
      </>


      <>
        <svg viewBox="0 0 100 50">
          <rect fill="#ffec9c" height="100%" width="100%"></rect>
        </svg>
        <br />
        <h3>Mellow Yellow</h3>
        <p>#ffec9c</p>
      </>

      <>
        <svg viewBox="0 0 100 50">
          <rect fill="#e53e5e" height="100%" width="100%"></rect>
        </svg>
        <br />
        <h3>Raspberry Red</h3>
        <p>#e53e5e</p>
      </>



                    <>
                      <svg viewBox="0 0 100 50">
                        <rect fill="#F4F2E9" height="100%" width="100%"></rect>
                      </svg>
                      <br />
                      <h3>Norwegian Wood</h3>
                      <p>#F4F2E9</p>
                    </>

                        <>
                          <svg viewBox="0 0 100 50">
                            <rect fill="#F2F2F4" height="100%" width="100%"></rect>
                          </svg>
                          <br />
                          <h3>Blue Steel</h3>
                          <p>#F2F2F4</p>
                        </>




              </Grid>







      </Section>
      <Section>

      <Grid grid="1-2">
        <></>
        <>
          <h2>Working with colors</h2>
          <p>There will be a natural variation of colour depending on the material of the output. Color prints on matte and coated paper will look different from each other, even when using the same color code. </p>

          <p>Always plan for a quality check of the produced material, to see if the actual output meets the expected quality. </p>

        <Downloadable>
          <IconDemo><Icon icon="externalLink" /></IconDemo>
          <div className="downloadable__content">
            <h3><a href="https://jxnblk.github.io/colorable/demos/matrix/" target="_blank" rel="noopener noreferrer">Colorable</a></h3>
            <p>An online tool for testing if different color cominations are WCAG compliant. </p>
          </div>
        </Downloadable>
      </>
    </Grid>

  </Section>


    <br />
    </Container>
    </div>
    )
  }
